import { render, staticRenderFns } from "./RightCharts.vue?vue&type=template&id=c8b020d4&scoped=true&"
import script from "./RightCharts.vue?vue&type=script&lang=js&"
export * from "./RightCharts.vue?vue&type=script&lang=js&"
import style0 from "./RightCharts.vue?vue&type=style&index=0&id=c8b020d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b020d4",
  null
  
)

export default component.exports